<span class="date-range-wrapper" *ngIf="(startDate && endDate) && (startDate != endDate) && selectedFilter!='custom'">
    <span>{{startDate | date:'dd MMM yyyy'}}</span> -
    <span>{{endDate| date:'dd MMM yyyy'}}</span>
</span>
<span *ngIf="(startDate && endDate) && (startDate == endDate)">
    <span>{{startDate | date:'dd MMM yyyy'}}</span>
</span>
<span class="navigation-button-wrapper">
    <button dlsButton class="pt-icon-only pt-quiet navigation-button"
            [disabled]="!isRightRangeEnabled"
            (click)="onRangeSelection(false)">
        <dls-icon class="pt-icon icon-dls-navigation-left"></dls-icon>
    </button>
    <button dlsButton class="pt-icon-only pt-quiet navigation-button"
            [disabled]="!isLeftRangeEnabled"
            (click)="onRangeSelection(true)">
        <dls-icon class="pt-icon icon-dls-navigation-right"></dls-icon>
    </button>
</span>
<dls-toggle-group mode="radio">
    <button class="trends-filter-type" dlsToggleButton *ngFor="let filter of filters" name="{{filter.code}}"
            [class.pt-selected]="selectedFilter === filter.code" value="left"
            (click)="onSelectedFilter(filter.code)">
        {{filter.display}}
    </button>
    <div class="custom-calender-wrapper" *ngIf="selectedFilter=='custom'">
        <p-calendar [(ngModel)]="rangeDates" [monthNavigator]="true" [yearNavigator]="true" [showIcon]="true" yearRange="1900:2100" showButtonBar="true" (onSelect)="onSelectDateRange()" selectionMode="range" inputId="customDateRange"></p-calendar>
    </div>
</dls-toggle-group>



